import actionTypes from '../actionTypes';

export function setRuleType(value) {
	return {
		type: actionTypes.GET_RULE_TYPE,
		payload: value,
	};
}

export function createRule(data) {
	return {
		type: actionTypes.GET_CREATE_RULE_DATA,
		payload: data,
	};
}

export function createRuleSuccess(result) {
	return {
		type: actionTypes.GET_CREATE_RULE_SUCCESS,
		payload: result,
	};
}

export function createRuleFailure(error) {
	return {
		type: actionTypes.GET_CREATE_RULE_FAILURE,
		payload: error,
	};
}

export function deleteRule(data) {
	return {
		type: actionTypes.DELETE_RULE,
		payload: data,
	};
}

export function deleteRuleSuccess(result) {
	return {
		type: actionTypes.DELETE_RULE_SUCCESS,
		payload: result,
	};
}

export function deleteRuleFailure(error) {
	return {
		type: actionTypes.DELETE_RULE_FAILURE,
		payload: error,
	};
}

export function refreshWatchList(payload) {
	return {
		type: actionTypes.REFRESH_WATCHLIST,
		payload,
	};
}

export function getSearchItemResults(payload) {
	return {
		type: actionTypes.GET_SEARCH_ITEM_RESULTS,
		payload,
	};
}
export function getSearchItemResultsSuccess(payload) {
	return {
		type: actionTypes.GET_SEARCH_ITEM_RESULTS_SUCCESS,
		payload,
	};
}
export function getSearchItemResultsFailure(payload) {
	return {
		type: actionTypes.GET_SEARCH_ITEM_RESULTS_FAILURE,
		payload,
	};
}
export function updateSearchItemResults(payload) {
	return {
		type: actionTypes.UPDATE_SEARCH_ITEM_RESULTS,
		payload,
	};
}
export function updateSelectedItem(payload) {
	return {
		type: actionTypes.UPDATE_SELECTED_ITEM,
		payload,
	};
}
export function updateCompareSelectedItemA(payload) {
	return {
		type: actionTypes.UPDATE_SELECTED_ITEM_A,
		payload,
	};
}
export function updateCompareSelectedItemB(payload) {
	return {
		type: actionTypes.UPDATE_SELECTED_ITEM_B,
		payload,
	};
}
export function updateAlertCheckBox(payload) {
	return {
		type: actionTypes.UPDATE_ADD_ITEM_CHECKBOX,
		payload,
	};
}
export function updateAddItemCheckBox(payload) {
	return {
		type: actionTypes.UPDATE_ADD_ITEM_CHECKBOX,
		payload,
	};
}

export function updateAddProductCheckBox(payload) {
	return {
		type: actionTypes.UPDATE_ADD_PRODUCT_CHECKBOX,
		payload,
	};
}

export function getBulkItemSearchResults(payload) {
	return {
		type: actionTypes.GET_BULK_ITEM_SEARCH_RESULTS,
		payload,
	};
}
export function getBulkItemSearchResultsSuccess(payload) {
	return {
		type: actionTypes.GET_BULK_ITEM_SEARCH_RESULTS_SUCCESS,
		payload,
	};
}
export function getBulkItemSearchResultsFailure(payload) {
	return {
		type: actionTypes.GET_BULK_ITEM_SEARCH_RESULTS_FAILURE,
		payload,
	};
}
export function updateBulkItemSearchResults(payload) {
	return {
		type: actionTypes.UPDATE_BULK_ITEM_SEARCH_RESULTS,
		payload,
	};
}

export function pollStartAction(payload) {
	return {
		type: actionTypes.POLL_START,
		payload: payload,
	};
}

export const getDataSuccessAction = (payload) => ({
	type: actionTypes.GET_DATA_SUCCESS,
	payload,
});

export const getDataFailureAction = (payload) => ({
	type: actionTypes.GET_DATA_FAILURE,
	payload,
});

export function putNotificationsRead(payload) {
	return {
		type: actionTypes.PUT_NOTIFICATIONS_READ,
		payload,
	};
}
export function putNotificationsReadSuccess(payload) {
	return {
		type: actionTypes.PUT_NOTIFICATIONS_READ_SUCCESS,
		payload,
	};
}
export function putNotificationsReadFailure(payload) {
	return {
		type: actionTypes.PUT_NOTIFICATIONS_READ_FAILURE,
		payload,
	};
}

export const getWatchList = (payload) => ({
	type: actionTypes.GET_WATCH_LIST,
	payload,
});
export const getWatchListSuccess = (payload) => ({
	type: actionTypes.GET_WATCH_LIST_SUCCESS,
	payload,
});
export const getWatchListFailure = (payload) => ({
	type: actionTypes.GET_WATCH_LIST_FAILURE,
	payload,
});

export const setIsCreateRuleOpen = (payload) => ({
	type: actionTypes.SET_IS_CREATE_RULE_OPEN,
	payload,
});

export const setIsCustomizeColOpen = (payload) => ({
	type: actionTypes.SET_IS_CUSTOMIZE_COL_OPEN,
	payload,
});

export const setIsWatchListOpen = (payload) => ({
	type: actionTypes.SET_IS_WATCH_LIST_OPEN,
	payload,
});

export const setIsNotificationOpen = (payload) => ({
	type: actionTypes.SET_IS_NOTIFICATION_OPEN,
	payload,
});

export const updateLastCreatedRule = (payload) => ({
	type: actionTypes.UPDATE_LAST_CREATED_RULE,
	payload,
});

export const getEditRuleData = (payload) => ({
	type: actionTypes.GET_EDIT_RULE_DATA,
	payload,
});

export const getSubRuleNotification = (payload) => ({
	type: actionTypes.GET_SUB_RULE_NOTIFICATION,
	payload,
});

export const getSubRuleNotificationSuccess = (payload) => ({
	type: actionTypes.GET_SUB_RULE_NOTIFICATION_SUCCESS,
	payload,
});

export const getSubRuleNotificationFailure = (payload) => ({
	type: actionTypes.GET_SUB_RULE_NOTIFICATION_FAILURE,
	payload,
});
